import PropTypes from 'prop-types';
import { memo } from 'react';
import { twMerge } from 'tailwind-merge';

import Button from 'shopper/components/Button';
import Icon from 'shopper/components/Icon';
import Text from 'shopper/components/Text';

import { sendEvent } from 'lib/gtag';
import { shareToWithText } from 'lib/share';

import SOCIAL_MEDIA from 'constants/socialMedia';

const SHAREABLE_SOCIAL_MEDIA = [
  {
    name: SOCIAL_MEDIA.FACEBOOK.TITLE,
    icon: <Icon name="facebook" />,
  },
  {
    name: SOCIAL_MEDIA.TWITTER.TITLE,
    icon: <Icon name="twitter" />,
  },
  {
    name: SOCIAL_MEDIA.WHATSAPP.TITLE,
    icon: <Icon name="whatsapp-filled" />,
  },
  {
    name: SOCIAL_MEDIA.TELEGRAM.TITLE,
    icon: <Icon name="telegram" />,
  },
];

const SocialMediaShare = ({
  articleTitle,
  className,
  gaEventCategory,
  ...rest
}) => (
  <div
    className={twMerge(
      'flex w-full flex-col items-center pt-4 md:w-min md:flex-row md:pt-0',
      className
    )}
    {...rest}
  >
    <Text className="mb-2 md:mb-0 md:mr-2" size="size2">
      Compartilhe:
    </Text>
    <div className="flex gap-x-2">
      {SHAREABLE_SOCIAL_MEDIA.map(({ icon, name }, index) => (
        <Button
          key={index}
          aria-label={`Compartilhe usando ${name}`}
          icon={icon}
          size="size4"
          type="neutral-ghost"
          onClick={() => {
            sendEvent({
              action: 'share',
              category: gaEventCategory,
              data: name.toLowerCase(),
            });
            shareToWithText(name, articleTitle);
          }}
        />
      ))}
    </div>
  </div>
);

SocialMediaShare.propTypes = {
  articleTitle: PropTypes.string.isRequired,
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  gaEventCategory: PropTypes.string.isRequired,
};

export default memo(SocialMediaShare);
